<template>
  <div class="custom-page-box">
    <a-card title="团队信息详情" :bordered="false" :headStyle="{fontSize:'18px'}">
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="['search_1','search_2','search_3','search_4','search_5']"
        :columns="getColumns()"
        :queryParams="queryParams"
        :leftSpace="30"
        :enableSearch='false'
        :customPagination="true"
        :requestPromise="getListPromise"
      >
        <a-form-item slot="search_1" label="姓名" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staff_name" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_2" label="手机号" v-bind="searchItemLayout">
          <a-input v-model="queryParams.staff_mobile" placeholder="请输入"/>
        </a-form-item>
        <a-form-item slot="search_3" label="注册时间" v-bind="searchItemLayout">
          <!--          :disabledDate="disabledDate"-->
          <a-range-picker
            :allowClear="false"
            @change="onDateChange"
            :value="selectedDate"
            style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_4" label="交易时间" v-bind="searchItemLayout">
          <a-range-picker
            :allowClear="false"
            @change="onDateTransactionChange"
            :value="transactionDate"
            style="width: 100%"/>
        </a-form-item>
        <a-form-item slot="search_5" v-bind="searchItemLayout" style='margin-left:3%'>
          <a-button type="primary" @click='onclickQuery'>查询</a-button>
          <a-button style="margin-left: 10px" @click="exportData">导出</a-button>
        </a-form-item>
      </search-page-view>
    </a-card>
  </div>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import moment from 'moment'

export default {
  name: 'TeamInformationDetail',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {
        staff_id: this.$route.query.staff_id,
        register_start_date: moment().subtract('days', 366).format('YYYY-MM-DD'),
        register_end_date: moment().subtract('days', 1).format('YYYY-MM-DD'),
        order_start_date: moment().subtract('days', 366).format('YYYY-MM-DD'),
        order_end_date: moment().subtract('days', 1).format('YYYY-MM-DD')
      },
      selectedDate: null,
      transactionDate: null
    }
  },
  mounted() {
    let startTime = moment().subtract('days', 366).format('YYYY-MM-DD')
    let endTime = moment().subtract('days', 1).format('YYYY-MM-DD')
    this.selectedDate = [moment(startTime), moment(endTime)]
    this.transactionDate = [moment(startTime), moment(endTime)]
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().subtract(1, 'days')
    },
    onclickQuery() {
      this.$refs.pageList.refresh(true)
    },
    exportData() {
      this.getHttpServices().getUserService().post('daily/report/staff/list/export', this.queryParams)
        .then(res => {
          this.getLogUtils().logWithTag('==exportDataList==', res)
          this.$message.success('操作成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.register_start_date = dateStrArr[0]//开始日期
      this.queryParams.register_end_date = dateStrArr[1]//结束日期
    },
    onDateTransactionChange(dates, dateStrArr) {
      this.transactionDate = dates
      this.queryParams.order_start_date = dateStrArr[0]//开始日期
      this.queryParams.order_end_date = dateStrArr[1]//结束日期
    },
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('daily/report/staff/list', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'staff_id'
        },
        {
          title: '姓名',
          dataIndex: 'staff_name'
        },
        {
          title: '手机号',
          dataIndex: 'staff_mobile'
        },
        {
          title: '订单数量',
          dataIndex: 'order_add_total_number'
        },
        {
          title: '营业额',
          dataIndex: 'sell_add_total_amount'
        },
        {
          title: '注册时间',
          dataIndex: 'staff_create_time'
        }
      ]
    }
  }

}
</script>
<style lang="less">
</style>